// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { alertSettingsActions, globalActions } from "src/actions";

import { IProps, TabId } from "@blueprintjs/core";

import { Route, Switch } from "react-router-dom";
import { ListHeader, StyledButton, ToggleButtons } from 'src/components';
import { SettingsGroupsListItem } from '../components';
import GroupsSettingsAdd from './group-settings-add';
import GroupsSettingsEdit from './group-settings-edit';

import { MPDList } from "src/mpd-library";

import "./styles.css";

interface IGroupsSettingsProps extends IProps {
  itemType: string;
  routeProps: any;
  manage?: any;
  onManageCheckBoxChanged: (itemType: string, itemId: string) => (dispatch: Dispatch<any>) => Promise<void>;
  onManageListChanged: (itemType: string, list: Array<any>) => (dispatch: Dispatch<any>) => Promise<void>;
  onUpdateToolBar: (
    topBarProps: any
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onChangeManageItemStatus: (status: any, itemType: string, itemId: string, history: any) => (dispatch: Dispatch<any>) => Promise<void>;
  onCloseRightPanel?(): void;
  onToggleRightPanel?(): void;
}

interface IGroupsSettingsState {
  list: Array<any>;
  filter?: string;
  sort?: Array<string> | string;
  selectedTabNum: TabId;
  tabs: Array<string>;
}

class GroupsSettings extends React.Component<IGroupsSettingsProps, IGroupsSettingsState> {
  constructor(props: IGroupsSettingsProps) {
    super(props);
    this.onChangeManageItemStatus = this.onChangeManageItemStatus.bind(this);
    this.onAddManageItem = this.onAddManageItem.bind(this);
    this.onGroupCheckBoxChanged = this.onGroupCheckBoxChanged.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
    this.onGroupsSelectChange = this.onGroupsSelectChange.bind(this);
    this.onGroupsSortChange = this.onGroupsSortChange.bind(this);
    const { itemType, manage } = this.props;
    const list = manage[itemType].list;

    this.updateToolBar(this.props.itemType);

    this.state = {
      list,
      selectedTabNum: 0,
      sort : ['title', 'description'],
      tabs: ['account', 'settings']
    }
  }

  public componentWillReceiveProps(nextProps: IGroupsSettingsProps) {
    if(nextProps.itemType !== this.props.itemType) {
      this.updateToolBar(nextProps.itemType);
    }
    if(nextProps.routeProps !== this.props.routeProps){
      this.updateToolBar(nextProps.itemType);
    }
    if(nextProps.manage[nextProps.itemType].list !== this.state.list){
      this.setState({ list: nextProps.manage[nextProps.itemType].list });
    }
  }

  public render() {
    const { className, itemType, onCloseRightPanel, onToggleRightPanel, routeProps } = this.props;
    const { filter, sort, list } = this.state;
    const FilteredList = MPDList(this.renderDisplayList);

    return (
      <div className={classNames('group-settings-container', className)}>
          <Switch location={routeProps.history.location}>
            <Route
              exact={true}
              path={"/alerts-settings/groups"}
              render={() => (
                <React.Fragment>
                  <ListHeader 
                    className='group-settings-list-header'
                    onSearchChange={this.onSearchChange}
                    onGroupsSelectChange={this.onGroupsSelectChange}
                    onGroupsSortChange={this.onGroupsSortChange}
                  />
                  <FilteredList 
                    filter={filter}
                    list={list} 
                    sort={sort}
                  />
                </React.Fragment> 
                )}
              />
            <Route
                path={"/alerts-settings/groups/add/"}
                render={() => (
                  <GroupsSettingsAdd 
                    itemType={itemType} 
                    routeProps={routeProps}
                    onCloseRightPanel={onCloseRightPanel}
                    onToggleRightPanel={onToggleRightPanel}
                  />
                )}
            />
            <Route
              path={"/alerts-settings/groups/edit/"}
              render={() => (
                <GroupsSettingsEdit
                  itemType={itemType}
                  routeProps={routeProps}
                  onCloseRightPanel={onCloseRightPanel}
                  onToggleRightPanel={onToggleRightPanel}
                />
              )}
            />
          </Switch>
      </div>
    );
  }

  private onGroupsSortChange(event: any) {
    let sort = event.currentTarget.textContent;
    switch(sort) {
      case 'A-Z': 
        sort = ['title', 'description'];
        break;
      case 'Private':
        sort = 'type';
        break;
      case 'Public':
        sort = '-type';
        break;
      default:
        break;
    }
    this.setState({ sort });
  }

  private onGroupsSelectChange(event: any) {
    const { manage, itemType } = this.props;
    const list = manage[itemType].list;
    const select = event.currentTarget.textContent;
    switch(select) {
      case 'All': 
        for (let i = 0; i < list.length; i++) {
          list[i].checked = true;
        }
        break;
      case 'None':
        for (let i = 0; i < list.length; i++) {
          list[i].checked = false;
        }
        break;
      default:
        break;
    }
    this.setState({ list });
  }

  private onSearchChange(event: any) {
    const filter = event.currentTarget.value;
    this.setState({ filter });
  }

  private renderDisplayList = (props: any) => (
    <React.Fragment>
      {props.list.map((group: any, index: number) => (
        <SettingsGroupsListItem
          key={index}
          onChange={e => this.onGroupCheckBoxChanged(e, group.id)}
          statusChanged={e => this.onChangeManageItemStatus(e, group.id)}
          active={group.active}
          checked={group.checked}
          description={group.description}
          members={group.members}
          title={group.title}
          type={group.type}
          status={group.active ? 'Active Since ' + group.date : 'Deactive'}
          statusOptions={['edit', 'delete', 'deactivate']}
        />
      ))}
    </React.Fragment>
  );

  private onChangeManageItemStatus(event: any, groupId: string) {
    const { itemType, routeProps } = this.props;
    const history = routeProps.history;
    const status = event.currentTarget.textContent;
    this.props.onChangeManageItemStatus(status ,itemType, groupId, history);
  }

  private onGroupCheckBoxChanged(event: any, groupId: string) {
    this.props.onManageCheckBoxChanged('groups', groupId);
  }
  
  private onAddManageItem(){
    const { routeProps } = this.props;
    routeProps.history.push('/alerts-settings/groups/add');
  }

  private updateToolBar(text: string) {
    const topBarProps = {
      leftElement: (
        <ToggleButtons
          label={text.charAt(0).toUpperCase() + text.slice(1)}
          onToggle={this.props.onToggleRightPanel}
          onClose={this.props.onCloseRightPanel}
        />
      ),
      rightElement: (
        <StyledButton 
          text='Add Group'
          onClick={this.onAddManageItem}
          type={'default-blue'}
        />
      )
    };
    if(this.props.onUpdateToolBar){
      this.props.onUpdateToolBar(topBarProps);
    }
  }
}

const mapStateToProps = (state: any) => {
  const {  alertSettings } = state;
  const { manage } = alertSettings;
  return {
    manage
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    onUpdateToolBar: bindActionCreators(
      globalActions.onUpdateToolBar,
      dispatch
    ),
    onChangeManageItemStatus: bindActionCreators(
      alertSettingsActions.onChangeManageItemStatus,
      dispatch
    ),
    onManageListChanged: bindActionCreators(
      alertSettingsActions.onManageListChanged,
      dispatch
    ),
    onManageCheckBoxChanged: bindActionCreators(
      alertSettingsActions.onManageCheckBoxChanged,
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupsSettings);



// WEBPACK FOOTER //
// ./src/controllers/alert-settings/groups-settings/groups-settings.tsx